import './QualityCheckTabs.scss'
import { Button, TabPanel } from "devextreme-react"
import { useRef } from "react"
import { ScheduleChecklists } from "../../checklist/component/ChecklistScheduleCalendar"
import { t } from "i18next"
import { SchedulerRef } from "devextreme-react/cjs/scheduler"
import { useTabNavigation } from '../../../core/hook/useTabNaviagation'
import QualityCheckList from '../component/list/QualityCheckList'
import { ActionBar, AppearWrapper, Left, Right } from '../../../core/components'

export default function QualityCheckTabs() {
    const schedulerRef = useRef<SchedulerRef>(null);

    const tabs = [
        { id: 0, view: "list", title: t("List"), component: <QualityCheckList /> },
        { id: 1, view: "calendar", title: t("Calendar"), component: <ScheduleChecklists ref={schedulerRef} occupiedHeight={230} /> }
    ]

    const tabNavigation = useTabNavigation(tabs, "list")

    const onAddScheduleClick = () => {
        if (schedulerRef.current) {
            const scheduler = schedulerRef.current?.instance();

            scheduler.showAppointmentPopup(
                {
                    startDate: new Date(),
                    endDate: new Date(new Date().setHours(new Date().getHours() + 1)),
                },
                true
            );
        }
    };

    return (
        <>
            <ActionBar>
                <Left>
                    <AppearWrapper show={tabNavigation.selectedTab === 1}>
                        <Button
                            className='border-radius-small shadow'
                            stylingMode="contained"
                            type="default"
                            onClick={onAddScheduleClick}>
                            {t("Schedule Checklists")}
                        </Button>
                    </AppearWrapper>
                </Left>
                <Right>
                    <TabPanel
                        className="border-radius-small quality-check-tabs"
                        height={'100%'}
                        selectedIndex={tabNavigation.selectedTab}
                        dataSource={tabs}
                        deferRendering
                        onSelectionChanged={tabNavigation.handleTabChange}>
                    </TabPanel>
                </Right>
            </ActionBar>
            {tabs[tabNavigation.selectedTab].component}
        </>
    )
}